import { GridColumns } from '@mui/x-data-grid-pro'
import {
  QualityControlAssignmentDto,
  VisualQualityControlType,
} from '@services/dtos'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import {
  getQualityControlAssignments,
  removeQualityControlAssignment,
  setQualityControlAssignmentFilters,
  updateQualityControlAssignment,
} from '@state/reducers/qualityControlAssignmentReducer'
import QualityControlAssignmentForm from '../forms/QualityControlAssignmentForm'

export default function QualityControlAssignmentsTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setQualityControlAssignmentFilters({ includeInactive: false }))
    }
  }, [])

  const columns: GridColumns<QualityControlAssignmentDto> = useMemo(
    () => [
      {
        field: 'compound',
        headerName: 'MRP',
        width: 200,
        valueGetter: (params) => params.row.compound.name,
      },
      {
        field: 'colorQualityControl',
        headerName: 'Contrôle Couleur',
        width: 150,
        valueGetter: (params) =>
          params.row.visualQualityControls.find(
            ({ type }) => type === VisualQualityControlType.COLOR,
          )?.label,
      },
      {
        field: 'appearanceQualityControl',
        headerName: 'Contrôle Aspect',
        width: 150,
        valueGetter: (params) =>
          params.row.visualQualityControls.find(
            ({ type }) => type === VisualQualityControlType.APPEARANCE,
          )?.label,
      },
      {
        field: 'customQualityControls',
        headerName: 'Contrôles Personnalisés',
        width: 200,
        valueGetter: (params) =>
          params.row.customQualityControls.map(({ label }) => label).join(', '),
      },
      {
        field: 'radiochemicalPurityPercent',
        headerName: 'Pureté radiopharmaceutique (%)',
        width: 150,
        valueGetter: (params) => params.row.radiochemicalPurityPercent,
      },
      {
        field: 'radionuclidicPurityPercent',
        headerName: 'Pureté radionuclidique (%)',
        width: 150,
        valueGetter: (params) => params.row.radionuclidicPurityPercent,
      },
      {
        field: 'phMinimum',
        headerName: 'pH Min',
        width: 70,
        valueGetter: (params) => params.row.phMinimum,
      },
      {
        field: 'phMaximum',
        headerName: 'pH Max',
        width: 70,
        valueGetter: (params) => params.row.phMaximum,
      },
    ],
    [],
  )

  return (
    <BaseConfigTable<QualityControlAssignmentDto>
      columns={columns}
      selectRows={(state) => state.qualityControlAssignment.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setQualityControlAssignmentFilters({ includeInactive: true }))
        return dispatch(getQualityControlAssignments())
      }}
      deleteThunk={removeQualityControlAssignment}
      toggleThunk={(id, isActive) =>
        updateQualityControlAssignment({ id, dto: { isActive } })
      }
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setQualityControlAssignmentFilters({ page }))
        dispatch(getQualityControlAssignments())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <QualityControlAssignmentForm
          editingQualityControlAssignment={editingItem}
          onClose={onClose}
        />
      )}
      resourceLabel="affectation contrôle qualité"
      resourcePrefix="l'"
      formMaxWidth="xl"
    />
  )
}
